(()=>{const root=window.Shopify?.routes?.root||'/';document.addEventListener('submit',async e=>{const form=e.target.closest('form.snob-quick-add');if(!form)return;e.preventDefault();const btn=form.querySelector('button[type="submit"]');if(btn&&btn.disabled)return;if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true')}try{const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},credentials:'same-origin',body:new FormData(form)});if(!response.ok)throw new Error('Unable to add this item');if(typeof window.openCartDrawer==='function'){await window.openCartDrawer()}else{window.location.assign(root+'cart')}}catch(err){console.error(err);if(btn)btn.title='Could not add item. Please try again.'}finally{if(btn){btn.disabled=false;btn.removeAttribute('aria-busy')}}})})();
/* Lightweight product gallery controls; native touch scrolling handles mobile swipes */
(()=>{
 const setup=()=>{
  const desktop=window.matchMedia('(min-width:750px)').matches;
  document.querySelectorAll('.snob-product-media .snob-product-image-gallery').forEach(gallery=>{
   const track=gallery.querySelector('.snob-product-image-track');
   if(!track||track.children.length<2)return;
   if(!desktop||gallery.dataset.snobArrowsReady==='true')return;
   gallery.dataset.snobArrowsReady='true';
   ['prev','next'].forEach(direction=>{
    const button=document.createElement('button');
    button.type='button';button.className='snob-gallery-arrow snob-gallery-arrow-'+direction;
    button.setAttribute('aria-label',direction==='next'?'Next product photo':'Previous product photo');
    button.innerHTML=direction==='next'?'&#8250;':'&#8249;';
    button.addEventListener('click',event=>{
     event.preventDefault();event.stopPropagation();
     track.scrollBy({left:(direction==='next'?1:-1)*gallery.clientWidth,behavior:'smooth'});
    });
    gallery.parentElement.append(button);
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
 window.addEventListener('resize',setup,{passive:true});
})();
